import { useEffect, useRef } from "react"
import { register } from "swiper/element/bundle"
import { PAGE_DATA_URL_PREFIX } from "../../helpers/helper"

register()
const CustomItemsSwiper = ({ products = [] }) => {
  const swiperRef = useRef(null)
  const prevRef = useRef(null)
  const nextRef = useRef(null)

  useEffect(() => {
    const params = {
      breakpoints: {
        0: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 6,
        },
      },
      // loop: true,
      // centeredSlides: true,
      navigation: { nextEl: nextRef.current, prevEl: prevRef.current },
    }

    Object.assign(swiperRef.current, params)
    swiperRef.current.initialize()
  }, [])

  return (
    <>
      <div className="lg:px-7 relative h-fit">
        <swiper-container init="false" ref={swiperRef}>
          {products?.map((product, index) => (
            <swiper-slide key={index} className="h-auto">
              <a
                href={product.href ?? ""}
                className="px-2 flex flex-col h-full"
                target="_blank"
                rel="noreferrer"
              >
                <img className="w-full max-w-full" src={PAGE_DATA_URL_PREFIX + product?.src} alt="" />
                <p className="flex-1 mt-2 text-left line-clamp-2 text-sm font-medium">
                  {product?.name}
                </p>
                <p className="mt-2 text-left text-sm">{product?.price}</p>
              </a>
            </swiper-slide>
          ))}
        </swiper-container>
        <div
          ref={prevRef}
          className="absolute top-2/4 left-[0.5rem] lg:left-[0%] translate-y-[-50%] w-[1.75rem] lg:w-[1.75rem] z-10 -mt-9"
        >
          <img
            className="w-full max-w-full rotate-180"
            src={`${PAGE_DATA_URL_PREFIX}/images/arrow.svg#chevron`}
            alt=""
          />
        </div>
        <div
          ref={nextRef}
          className="absolute top-2/4 right-[0.5rem] lg:right-[0%] translate-y-[-50%] w-[1.75rem] lg:w-[1.75rem] z-10 -mt-9"
        >
          <img
            className="w-full max-w-full"
            src={`${PAGE_DATA_URL_PREFIX}/images/arrow.svg#chevron`}
            alt=""
          />
        </div>
      </div>
    </>
  )
}

export default CustomItemsSwiper
